module.exports = __webpack_public_path__ + "img/art_3.d7009d9b.png";